import React, { useRef, useState } from "react";
import "./index.scss";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ListSubheader from "@mui/material/ListSubheader";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    className: "custom-select-options-wrapper",
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const CustomSingleSelect = ({
  label,
  name,
  onChange,
  className,
  options,
  selectedValue,
  placeholder,
  disabled = false,
  isRequired,
  isError,
  onBlur,
  isMultiple = false,
}) => {
  const selectRef = useRef(null);
  const [openList, setOpenList] = useState(false);

  const handleDelete = (deleteOption) => {
    if(isMultiple){
      const filterOptions = selectedValue?.filter(
        (option) => option?.id !== parseInt(deleteOption)
      );
      onChange(filterOptions);
    }
  };

  const getRenderValue = (selected) => {
    if (isMultiple) {
      if (!selected) {
        return <span className="place-holder">{placeholder}</span>;
      }
      return (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
          {selectedValue.map((value) => (
            <Chip
              key={value?.id}
              label={value?.key}
              className="py-1 px-2 me-2"
              deleteIcon={<HighlightOffIcon />}
              onDelete={(e) => {
                e.stopPropagation();
                handleDelete(value?.id);
              }}
            />
          ))}
        </Box>
      );
    } else {
      if (!selected) {
        return <span className="place-holder">{placeholder}</span>;
      }
      return selected;
    }
  };

  const getSelectIcon = () => (
    <span className="arrow">
      <ArrowBackIosNewIcon
        className={`${openList ? "open-sublist-arrow" : "close-sublist-arrow"}`}
      />
    </span>
  );
  const handleChange = (option) => {
    if (isMultiple) {
      onChange([...selectedValue, option]);
    } else {
      onChange(option);
    }
  };

  const getValue = () => {
    if (isMultiple) {
      return selectedValue.map((option) => `${option?.id},${option?.key}`);
    } else {
      return selectedValue?.key || "";
    }
  };

  const getSelectedStatus = (id) => {
    if (isMultiple) {
      return selectedValue.some((option) => option?.id === id);
    } else {
      return selectedValue?.id === id;
    }
  };
  return (
    <div className={`${className} select-continer`} ref={selectRef}>
      {label && (
        <label className="input-label" htmlFor={name}>
          {label}
          {isRequired && <span className="star">*</span>}
        </label>
      )}
      <Select
        labelId={name}
        id={name}
        displayEmpty
        renderValue={getRenderValue}
        name={name}
        value={getValue()}
        onBlur={onBlur}
        open={openList}
        MenuProps={MenuProps}
        onOpen={(e, c, v) => {
          if (e.target.nodeName !== "svg" && e.target.nodeName !== "path") {
            setOpenList(!openList);
          }
        }}
        onClose={() => setOpenList(!openList)}
        IconComponent={getSelectIcon}
        className={`custom-select-wrapper w-100 ${
          isError ? "error-select" : ""
        }`}
        disabled={disabled}
        multiple={isMultiple}
      >
        {options?.length > 0 ? (
          options.map((option) =>
            option?.isSubOptionsAvailable
              ? [
                  ListSubheader && (
                    <ListSubheader key={`subheader-${option.id}`}>
                      <abbr title={option.key}>
                        <span>
                          {option?.subValue ? `-${option.key}` : option.key}
                        </span>
                      </abbr>
                    </ListSubheader>
                  ),
                  ...option.subOptions.map((subOption) => (
                    <MenuItem
                      key={subOption.id}
                      value={subOption.key}
                      onClick={() => {
                        if (!getSelectedStatus(subOption?.id)) {
                          handleChange(subOption);
                        } else {
                          handleDelete(subOption?.id);
                        }
                        setOpenList(!openList);
                      }}
                      className={`${
                        getSelectedStatus(subOption?.id)
                          ? "selected-subOption"
                          : ""
                      } ${subOption?.subValue ? "subOption" : ""}`}
                    >
                      <abbr title={subOption.key}>
                        <span>{subOption.key}</span>
                      </abbr>
                    </MenuItem>
                  )),
                ]
              : (
                <MenuItem
                  key={option?.id}
                  value={option.key}
                  onClick={() => {
                    if (!getSelectedStatus(option?.id)) {
                      handleChange(option);
                    } else {
                      handleDelete(option?.id);
                    }
                  }}
                  className={`${
                    getSelectedStatus(option?.id) ? "selected-option" : ""
                  } ${option?.subValue ? "subOption" : ""}`}
                >
                  <abbr title={option.key}>
                    <span>
                      {option?.subValue ? `-${option.key}` : option.key}
                    </span>
                  </abbr>
                </MenuItem>
              )
          )
        ) : (
          <MenuItem key={"No Option"}>No Data</MenuItem>
        )}
      </Select>
    </div>
  );
};

export default CustomSingleSelect;
